import React from 'react';
import { useSelector } from 'react-redux';

import { fieldErrorsSelector } from 'features/creditManagement';
import FieldErrors from 'components/FieldErrors';
import ManageCreditConfirmModal from './ManageCreditConfirmModal';
import ManageCreditCountField from './ManageCreditCountField';
import ManageCreditEmailField from './ManageCreditEmailField';
import ManageCreditNote from './ManageCreditNote';
import ManageCreditRadioField from './ManageCreditRadioField';
import ManageCreditReasonField from './ManageCreditReasonField';
import ManageCreditSubmitButton from './ManageCreditSubmitButton';
import styles from './CreditManagementPage.module.scss';

function CreditManagementPage() {
  const fieldErrors = useSelector(fieldErrorsSelector);

  return (
    <>
      <div className={styles.root}>
        <div className={styles.fieldSection}>
          <ManageCreditRadioField />
          <ManageCreditEmailField />
          <ManageCreditCountField />
          <ManageCreditReasonField />
          <FieldErrors
            className="m-v-20"
            name={'creditManagementErrors'}
            errors={fieldErrors}
          />
          <ManageCreditSubmitButton />
        </div>
        <ManageCreditNote />
      </div>
      {/* [Modal] all modals below */}
      <ManageCreditConfirmModal />
    </>
  );
}

export default CreditManagementPage;
